import { useMutation } from '@tanstack/react-query';

import { post } from '@front/common/src/api/requester';

import { SignupResponse } from '../types/pro';

export type CalendlyScheduledBody = {
  event: string;
  payload: {
    event: string;
    email: string;
    text_reminder_number: string;
    questions_and_answers: [
      {
        question: string;
        answer: string;
      },
    ];
  };
};

export const generateCalendlyScheduledBody = ({
  email,
  phone,
  event,
}: Pick<SignupResponse, 'email' | 'phone'> & { event: string }): CalendlyScheduledBody => ({
  event: 'invitee.created',
  payload: {
    event,
    email,
    text_reminder_number: phone,
    questions_and_answers: [
      {
        question: 'Portable',
        answer: phone,
      },
    ],
  },
});

const api = {
  post: (body: CalendlyScheduledBody) =>
    post('/calendly/events', {
      body,
      // Remove the warning about window keyword
      // @ts-ignore
      baseUrl: `${window.wecasa.siteUrl}api`,
      skipJsonParsing: true,
    }),
};

export const usePostCalendlyScheduledEvent = () => {
  const {
    mutate: scheduledCalendlyPost,
    isLoading: isScheduledCalendlyPosting,
    isError: isScheduledCalendlyError,
    isSuccess: isScheduledCalendlySuccess,
  } = useMutation({ mutationFn: api.post });
  return { scheduledCalendlyPost, isScheduledCalendlyPosting, isScheduledCalendlyError, isScheduledCalendlySuccess };
};
